import {Pipe, PipeTransform} from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

@Pipe({
  name: 'youtubeThumb'
})
export class YoutubeThumbPipe implements PipeTransform {

  constructor(private http: Http) {}

  transform(obj: any) {

  }


  }





// WEBPACK FOOTER //
// ./src/app/shared/form-media/video.pipe.ts